<div class="app-event-list__group">
  <h2>{{ date | date: "MMMM yyyy" }}</h2>
  <ng-container *ngIf="seriesStage as series">
    <app-wa-table
      [isSortableFunc]="sortClass"
      [showCondition]="true"
      [headers]="headers"
      [isDataLoading]="false"
      [areMoreData]="false"
      (loadMore)="loadMore()"
      [data]="series"
      (headerClick)="changeSort($event)"
    >
      <ng-template [extraClass]="['column-logo']" app-column let-stage>
        <div
          appCompetitionLink
          [isImage]="true"
          [size]="125"
          [competitionId]="stage.ID"
        ></div>
      </ng-template>
      <ng-template [extraClass]="['column-place']" app-column let-stage>
        <a
          appCompetitionLink
          [competitionId]="stage.ID"
          class="uppertext-black-no-viewport"
          >{{ stage.NameShort ? stage.NameShort : stage.Name }}</a
        >
        <div class="uppertext-no-viewport">
          {{ stage.Place }}, {{ stage.CountryName }}
          <lib-country-flag [id]="stage.Country"></lib-country-flag>
        </div>
      </ng-template>
      <ng-template
        [extraClass]="['center-text', 'column-date']"
        app-column
        let-stage
      >
        <div
          class="uppertext-black-no-viewport date-number"
          *ngIf="checkSameDay(stage.DFrom, stage.DTo) === false"
        >
          {{ stage.DFrom | date: "d" + "-" }}{{ stage.DTo | date: "d" }}
        </div>
        <div
          class="uppertext-black-no-viewport date-number"
          *ngIf="checkSameDay(stage.DFrom, stage.DTo) === true"
        >
          {{ stage.DFrom | date: "d" }}
        </div>
        <div class="uppertext-no-viewport date-month">
          {{ stage.DFrom | date: "MMMM yyyy" }}
        </div>
      </ng-template>
      <ng-template [extraClass]="['column-stage']" app-column let-stage>
        <div
          class="event-item__stage-level"
          [ngClass]="'stagelevel stagelevel--' + stage.StageLevel"
        ></div>
      </ng-template>
      <ng-template [extraClass]="['column-links']" app-column let-stage>
        <div class="event-item__actions" *ngIf="stage.Links; else space">
          <div
            class="icon icon--web uppertext-no-viewport"
            *ngIf="stage.Links.Web"
          >
            <a [href]="standartLink(stage.Links.Web)">{{'Website' | transloco}}</a>
          </div>
          <div
            class="icon icon--registration uppertext-no-viewport"
            *ngIf="stage.Links['Registration URL']"
          >
            <a [href]="standartLink(stage.Links['Registration URL'])"
              >{{'Registration' | transloco}}</a
            >
          </div>
          <div
            class="icon icon--results uppertext-no-viewport"
            *ngIf="stage.Links['Result URL']"
          >
            <a [href]="standartLink(stage.Links['Result URL'])">{{'Results' | transloco}}</a>
          </div>
        </div>
        <ng-template #space><div>&nbsp;</div> </ng-template>
      </ng-template>
      <ng-template app-column-responsive let-stage>

          <tr>
            <td>
              <div
                style="margin-right: 10px;"
                appCompetitionLink
                [isImage]="true"
                [size]="60"
                [competitionId]="stage.ID"
                [lazyLoad]="
                  'https://extranet.worldarchery.sport/CompetitionLogos/?Id=' +
                  stage.ID +
                  '&Size=75'
                "
              ></div>
            </td>
            <td>
              <div>
                <a
                appCompetitionLink
                [competitionId]="stage.ID"
                class="uppertext-black-no-viewport"
                >{{ stage.NameShort ? stage.NameShort : stage.Name }}</a
              >
                <div class="uppertext-no-viewport">
                  {{ stage.Place }}, {{ stage.CountryName }}
                  <lib-country-flag [id]="stage.Country"></lib-country-flag>
                </div>
              </div>

            </td>

          </tr>
          <tr>
            <td>
              <div
                style="margin-top:9px; margin-left:16px;height: 55px;width: 55px;"
                class="event-item__stage-level"
                [ngClass]="'stagelevel stagelevel--' + stage.StageLevel"
              >
          </div>
            </td>
            <td>
              <div class="border-content before">
                <div style="display: flex; flex-direction: row;">
                  <div>
                    <div
                      style="text-align: left;"
                      class=" uppertext-black-no-viewport date-number"
                      *ngIf="checkSameDay(stage.DFrom, stage.DTo) === false"
                    >
                      {{ stage.DFrom | date: "d" + "-"
                      }}{{ stage.DTo | date: "d" }}
                    </div>
                    <div
                      style="text-align: left;"
                      class="uppertext-black-no-viewport date-number"
                      *ngIf="checkSameDay(stage.DFrom, stage.DTo) === true"
                    >
                      {{ stage.DFrom | date: "d" }}
                    </div>
                    <div
                      style="text-align: left;"
                      class="uppertext-no-viewport date-month"
                    >
                      {{ stage.DFrom | date: "MMMM yyyy" }}
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </td>

          </tr>
          <tr>
            <td></td>
            <td rowspan="2">
              <div *ngIf="stage.Links; else space" class="border-content before">
                <div>
                  <div
                    class="icon icon--web uppertext-no-viewport"
                    *ngIf="stage.Links.Web"
                  >
                    <a [href]="standartLink(stage.Links.Web)">{{'Website' | transloco}}</a>
                  </div>
                  <div
                    class="icon icon--registration uppertext-no-viewport"
                    *ngIf="stage.Links['Registration URL']"
                  >
                    <a [href]="standartLink(stage.Links['Registration URL'])"
                      >{{'Registration' | transloco}}</a
                    >
                  </div>
                  <div
                    class="icon icon--results uppertext-no-viewport"
                    *ngIf="stage.Links['Result URL']"
                  >
                    <a [href]="standartLink(stage.Links['Result URL'])"
                      >{{'Results' | transloco}}</a
                    >
                  </div>
                </div>
              </div>
            </td>
          </tr>
      </ng-template>
    </app-wa-table>
  </ng-container>
  <!--<div class="event-item__logo"><img [lazyLoad]="'https://extranet.worldarchery.sport/CompetitionLogos/?Id='+stage.id+'&Size=300'"
      /></div>
    <div class="event-item__info">
      <div class="event-item__info__name"><a [href]="'https://worldarchery.sport/competition/'+stage.id">{{stage.name+' '}}</a></div>
      <div class="event-item__info__location">
        <div class="event-item__place">{{stage.place+', '}}</div>
        <div class="event-item__country">{{stage.countryname}}</div>
        <div class="event-item__flag"><img [lazyLoad]="'https://extranet.worldarchery.sport/Flags/'+stage.country+'.svg'" /></div>
      </div>
    </div>
    <div class="event-item__date">
      <div class="event-item__date__numbers" *ngIf="checkSameDay(stage.dateFromObj, stage.dateToObj)===false">{{stage.dateFromObj
        | date :'d' + '-'}}{{stage.dateToObj | date : 'd'}}</div>
      <div class="event-item__date__numbers" *ngIf="checkSameDay(stage.dateFromObj, stage.dateToObj)===true">{{stage.dateFromObj
        | date :'d'}}</div>
      <div class="event-item__date__month">{{stage.dateFromObj | date :'MMMM yyyy'}}</div>
    </div>
    <div class="event-item__stage-level" [ngClass]="'stagelevel-' + stage.stagelevel"></div>
    <div class="event-item__actions" *ngIf="stage.links">
      <div class="event-item__action_website" *ngIf="stage.links.Web"><a [href]="standartLink(stage.links.Web)">Website</a></div>
      <div class="event-item__action_registration" *ngIf="stage.links['Registration URL']"><a [href]="standartLink(stage.links['Registration URL'])">Registration</a></div>
      <div class="event-item__action_results" *ngIf="stage.links['Result URL']"><a [href]="standartLink(stage.links['Result URL'])">Results</a></div>
    </div>
  </div>
--></div>
